import { LOGO_HERE } from '../business/business.constants';

export const createNoCacheExtraImageUrl =  (imageUrl: string): string => 
  (imageUrl.indexOf('data:image') === -1) ? '?' + new Date().getTime() : '';

export const getBusinessLogoUrl = (businessLogoUrl: string): string =>
  businessLogoUrl ? businessLogoUrl + createNoCacheExtraImageUrl(businessLogoUrl) : LOGO_HERE;


// WEBPACK FOOTER //
// ./src/util/image.util.tsx